import React from 'react';
import NewsletterHTML from '../../components/NewsletterHTML';
import {
  NewsletterPreviewContainer,
  Banner,
  NewsletterSection,
  NewsletterMeta,
  NewsletterSectionContent,
  BrandContainer,
} from './NewsletterPreview.styles';
import {
  useNewsletterPreview,
} from '../../hooks'

import LOGO from '../../assets/QS_branding_favicon.png';

const NewsletterPreview = () => {
  const newsletter = useNewsletterPreview();

  return (
    <NewsletterPreviewContainer>
      <Banner>
        <p> {`Today's newsletter will reach 75,000 gamers just like you`} </p>
        <p> {`Check out the latest issue below and don't forget to subscribe`} </p>
      </Banner>
      <NewsletterSection>
        <NewsletterSectionContent>
          <BrandContainer>
            <img src={LOGO} alt='Logo for Quickscope - Daily Gaming Newsletter' />
            <p> Quickscope </p>
          </BrandContainer>
          <NewsletterMeta>
            { newsletter && <p><span> {newsletter.subject_line} </span></p> }
            <p> {`To: Quickscope Readers`} </p>
          </NewsletterMeta>
          {
            newsletter &&  <NewsletterHTML html={newsletter.email} />
          }
        </NewsletterSectionContent>
      </NewsletterSection>
    </NewsletterPreviewContainer>
  );
}

export default NewsletterPreview;